import React from 'react';
import './EventPage.css';

import { PageTitle,Event, Heading } from '../../../components';
import { events } from '../../../constants';



const EventPage = () => {  
  return (  
    <>  
      {/* Page Title */}
      <PageTitle title={'Events'} page={'Events'} />

      {/* Events Section */}
      <section className='events'>

        {/* Section heading */}
        <Heading title={'Events We Cater'} subTitle={'Discover Our Catering Services'} />

        <div className='box-container'>
          {/* Loop through the events array and render each event */}
          {events.map((event) => (
            <Event key={event.id} event={event} />
          ))}
        </div>

      </section>
    </>
  );
}

export default EventPage;